'use strict';

module.exports = require('./lib/ReactDOMServer');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/server.js
 ** module id = 3348
 ** module chunks = 0
 **/